/*  MUI  */
import { Alert, Box, Paper } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Internal */
import { ReportSummary } from '../ReportSummary';

export const ReportHasNoData = ({ renderingScheduledReport, reportSetup }) => {
    const { t } = useTranslation();

    return (
        <Paper elevation={0} variant="outlined" data-trackid="reportHasNoData">
            <Box p="8px">
                {renderingScheduledReport && (
                    <ReportSummary
                        renderingScheduledReport={renderingScheduledReport}
                        reportSetup={reportSetup}
                        title={t('Reports.report_setup')}
                    />
                )}
                <Alert severity="warning" icon={false}>
                    {t('Report.no_data_notice')}
                </Alert>
            </Box>
        </Paper>
    );
};
